import {uuid4} from "@capacitor/core/dist/esm/util";
import firebase from "firebase";
import Timestamp = firebase.firestore.Timestamp;


export enum TaskState{
    ToDo= "todo",
    Doing= "doing",
    Done= "done",
}
export interface Task{
    id: string;
    owner: string | undefined;
    name: string;
    priority: number;
    difficulty: number;
    deadline: Date | Timestamp | null;
    description: string;
    duration: number;
    reviews: string[];
    category: string;
    customCategory: string;
    state: TaskState;
    usedTools: string[]|undefined;
}

export class TaskUtils{
    public static asDate(d: Date|Timestamp|null): Date{
        if(d && 'toDate' in d ){
            return d.toDate()
        }else if(!d){
            return new Date()
        }
        return d as Date;
    }
}

export class I18nUtils{
    public static toString(m: MultilangText,locale = ""): string{
        //tODO: momentan nur deutsch:
        return m.de;
        // if(!locale) locale = "de";
        // //TODO: mehrsprachigkeit dynamischer
        // let res =m.de
        // if(locale.toLowerCase().startsWith('en')) res = m.en;
        // if(!res) return "";
        // else return res
    }
}

export function createEmptyTask(duration: number): Task{
    return {
        owner: "",
        id:uuid4(),
        state:TaskState.ToDo,
        priority: 1,
        name:"",
        duration:duration,
        difficulty:1,
        description:"",
        reviews:[],
        category: "",
        customCategory: "",
        deadline: new Date(),
        usedTools: []
    }
}


export function createEmptyTool(): Tool{
    return {
        id: "",

        i18nTitle: {de: ""},
        i18nShortTitle: {de: ""},
        title: "",
        shortTitle: "",
        i18nContent: [],
        content: [],
        order: 0
    }
}

export function createEmptyReview(tasks: string[]): Review{
    return {
        created: new Date(),
        owner:"",
        name: "",
        tasks: tasks,
        id:""
    }
}
export function createFromTask(task: Task): Task{
    return {
        ...task
    }
}

export interface Goal{
    id: string;
    name: string;
    tasks: Task[];
}

export interface User{
    id: string | undefined;
    data: any | null;
}
export interface Review{
    id: string;
    owner: string | undefined;
    created: Date | Timestamp | null;
    name: string;
    tasks: string[];
}

export interface Category{
    parent: string | undefined;
    id: string;
    order: number;
    i18nTitle: MultilangText;
    title: string;
}

export interface TaskByDayGroup{
    day: Date;
    taske: Task[];
}

export interface MultilangText {
    de: string;
    // en: string;
}

export interface Tool{
    id: string;
    i18nTitle: MultilangText;
    i18nShortTitle: MultilangText;
    title: string;
    shortTitle: string;
    i18nContent: MultilangText[];
    content: string[];
    order: number;
}

export class ToolUtils{
    public static translate(tool: Tool,locale=""): Tool{
        const title = I18nUtils.toString(tool.i18nTitle,locale)
        const shortTitle = I18nUtils.toString(tool.i18nShortTitle,locale)
        const content = tool.i18nContent.map(c=>I18nUtils.toString(c,locale))
        return {
            ...tool,
            title,
            shortTitle,
            content,
        }
    }
}

export interface State{
    user: User;
    tasks: Task[];
    // goals: Goal[];
    reviews: Review[];
    categories: Category[];
    tools: Tool[];
}

